
import ZoneFunnelChart from '../components/zoneReport/ZoneChart.vue';
import ZoneKpiTable from '../components/zoneReport/ZoneKpiTable.vue';
// import ZoneImageUpload from '../components/zoneReport/ZoneImageUpload.vue';
import GenderTable from '../components/zoneReport/GenderTable.vue';
import ZonePieChart from '../components/zoneReport/ZonePieChart.vue';
import ZoneGenderRatePie from '../components/zoneReport/ZoneGenderRatePie.vue';
import DwellTimeChart from '../components/zoneReport/DwellTimeChart.vue';
import { addKpiCustomization } from '@/util/kpis';
import { mapState, mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import Status from '@/models/onboarding/Status';
import { formatValues } from '@/api/apiDataManagers/calc_consts';
import store from '@/store';
import Vue from 'vue';
import { APIFetchTrafficPowerHourV2 } from '@/api/traffic';

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {
    ZoneFunnelChart,
    ZoneKpiTable,
    // ZoneImageUpload,
    GenderTable,
    ZonePieChart,
    ZoneGenderRatePie
    // DwellTimeChart
  },
  data() {
    return {
      coronaBannerReadStatus: true,
      lastTimeStamp: Date.now(),
      lastDateUploaded: '',
      onboardingStatus: Status.DONE,
      overviewLoading: false,
      boxTargetLoading: false,
      comparisionLoading: false,
      overViewKpiList: [],
      apiTimer: 0,
      lastModifiedJsonData: {},
      hasFetchedPref: false,
      apiTimeout: 0,
      canShowSurvey: false,
      zones: {},
      dwc: {},
      dwellData: [],
      loading: false,
      config:["0-1", "1-2", "2-3", "3-4", "4-5","5-6", "6-7", "7-8", "8-9", "9-10", "10-20", "20+"]
    };
  },
  computed: {
    ...mapGetters('tenant', ['hasResetAccount', 'isNewAccount']),
    ...mapState('overview', { overViewKpis: 'kpis' }),
    ...mapState('overview', [
      'regions',
      'districts',
      'stores',
      'groups',
      'SVs',
      'allTrends'
    ]),
    ...mapState('user', ['kpiPreferences', 'kpiLabelValue', 'getLocale']),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState',
      'getCustom445DateRange'
    ]),

    // ...mapState('comparison', ['regions', 'districts', 'stores', 'groups', 'SVs']),
    ...mapState('target', ['targets', 'callTracker'])
  },
  watch: {
    kpiPreferences(newValue) {
      this.overViewKpiList =
        this.kpis && this.filterData(addKpiCustomization(this.kpis));
    },
    getStartingPeriod: {
      handler(newQuestion) {
        this.refreshAction();
      }
      // immediate: true
    }
  },
  mounted() {
    this.overviewLoading = true;
    Vue.prototype?.$mixpanel?.track('zone-report', {
      referrer: document.referrer
    });
  },

  methods: {
    ...mapActions('comparison', ['fetchAllComparision']),
    ...mapActions('overview', ['fetchOverview', 'setDataByLocationFormatKey']),
    ...mapActions('weather', ['getWeather']),
    ...mapActions('user', ['fetchKpiPreferences']),
    //
    async refreshAction() {
      clearTimeout(this.apiTimeout);
      const _this = this;
      this.apiTimeout = setTimeout(async function() {
        await _this.fetchKpiPreferences();
        setTimeout(
          async () => {
            _this.lastTimeStamp = Date.now();
            _this.refreshOverview();
            // _this.lastDateUploaded = await _this.calcLastTimeStamp();
            _this.hasFetchedPref = true;
          },
          _this.hasFetchedPref ? 0 : 1000
        );
      }, 500);
    },
    async refreshPage() {
      clearTimeout(this.apiTimer);
      this.apiTimer = setTimeout(this.refreshAction, 200);
    },

    getParamsForOverview() {
      let stC = this.getStoreCodesList;
      if (!stC) {
        return;
      }
      return {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        compareStartDate: this.getStartingCompared,
        compareEndDate: this.getEndingCompared,
        storeCodes: stC,
        daysOfWeek: this.getDaysOfWeekList,
        useCustomCalender: this.getCustomCalenderState,
        groupByMetricKey: true,
        comparisonYKPIMetricKey: ([...this.kpiLabelValue][0] ?? {})?.value
        // kpis: this.customSort.join(',')
      };
    },
    filterData(data) {
      const keys = ['pb', 'trf', 'trn'];
      const sortOrder = ['pb', 'trf', 'zP', 'zS', 'trn'];
      //
      const totalStops = Object.values(this.zones.selected).reduce(
        (sum, entry) => sum + entry.summary.stops,
        0
      );
      const totalPb = Object.values(this.zones.selected).reduce(
        (sum, entry) => sum + entry.summary.pb,
        0
      );
      //
      const totalStopsC = Object.values(this.zones?.compared).reduce(
        (sum, entry) => sum + entry.summary.stops,
        0
      );
      const totalPbC = Object.values(this.zones?.compared).reduce(
        (sum, entry) => sum + entry.summary.pb,
        0
      );
      //
      const f = data?.filter(item => keys.includes(item.metricKey));
      const addkey = f.map(i => {
        const percentage = i.variationPercentage.replace('%', '');
        return { ...i, percentage };
      });
      const trans = this.$store.state.user.translate;
      return [
        ...addkey,
        {
          title: trans?.zone_stops,
          metricKey: 'zS',
          value: totalStops?.toLocaleString(),
          comparedValue: totalStopsC?.toLocaleString()
        },
        {
          title: trans?.zone_passerby,
          metricKey: 'zP',
          value: totalPb?.toLocaleString(),
          comparedValue: totalPbC?.toLocaleString()
        }
      ]?.sort(
        (x, y) =>
          sortOrder.indexOf(x.metricKey) - sortOrder.indexOf(y.metricKey)
      );
    },
    makeDwellData(data) {
      const uniqueDateStorePairs = new Set();
      const transformedData = data.map(({ _id, zone }) => {
        const [date, hour, , storeCode] = _id.split('_');
        uniqueDateStorePairs.add(`${date}_${storeCode}`);
        const dwell = Object.values(zone || {}).reduce(
          (sum, { dwell }) => sum + (dwell > 0 ? dwell : 0),
          0
        );
        const stops = Object.values(zone || {}).reduce(
          (sum, { stops }) => sum + (stops > 0 ? stops : 0),
          0
        );
        return { date, hour, storeCode, dwell, stops };
      });
      const groupBy = key =>
        Object.values(
          transformedData.reduce((acc, item) => {
            const groupKey = item[key];
            if (!acc[groupKey]) {
              acc[groupKey] = { [key]: groupKey, dwell: 0, stops: 0 };
            }
            acc[groupKey].dwell += item.dwell || 0;
            acc[groupKey].stops += item.stops || 0;
            acc[groupKey].dividOn = uniqueDateStorePairs.size;
            return acc;
          }, {})
        )?.sort((a, b) => a[key] - b[key]);
      return groupBy('date')?.map(item => {
        // new
        const avgDwell = item.dwell / item.stops;
        //
        return {
          ...item,
          formatedValue: formatValues(Math.floor(avgDwell / item.dividOn), 'dw')
        };
      });
    },
    formatSummary(summary) {
      return Object.entries(summary)
        .map(([key, value]) => ({ key, value }))
        .sort((a, b) =>
          a.key.localeCompare(b.key, undefined, { numeric: true })
        );
    },
    getAllDWC(data) {
      const dwcData = {};
      for (const section in data) {
        if (data[section].zones) {
          for (const zoneKey in data[section].zones) {
            const dwc = data[section].zones[zoneKey]?.dwc;
            if (dwc && Object.keys(dwc).length > 0) {
              this.config?.forEach(key => {
                if(!dwc[key]){
                  dwc[key] = 0;
                }
              })
              dwcData[zoneKey] = this.formatSummary(dwc);
            }
          }
        }
      }
      return dwcData;
    },
    async refreshOverview() {
      try {
        this.overviewLoading = true;

        let params = this.getParamsForOverview();
        if (params) {
          let str = JSON.stringify(params);
          params.trackLatest = { callerId: 'home', value: str };
          let isActionable = await this.fetchOverview(params);
          const { zones, kpis } = await APIFetchTrafficPowerHourV2({
            ...params,
            zone: true
          });
          // const isHour = params.startDate === params.endDate;
          const dwellData = this.makeDwellData(kpis);
          const sDwc = this.getAllDWC(zones.selected);
          this.dwc = sDwc;
          this.dwellData = dwellData;
          this.zones = { selected: zones.selected, compared: zones.compared };
          if (isActionable) {
            const resData = this.filterData(
              addKpiCustomization(this.overViewKpis)
            );
            const getMetricValue = key => {
              const value = resData.find(item => item.metricKey === key)?.value;
              return Number(value?.toString().replace(/[,人件]/g, '')) || 0;
            };

            const trf = getMetricValue('trf');
            const trn = getMetricValue('trn');
            const zP = getMetricValue('zP');
            const zS = getMetricValue('zS');
            const pb = getMetricValue('pb');
            const highestValue = Math.max(trf, trn, zP, zS, pb);

            //
            const formula = (a, b) => {
              const result = (a / b) * 100;
              return Number.isFinite(result) ? result : 0;
            };
            //
            const addPer = resData.map(item => {
              if (item.metricKey === 'zP') {
                item.percentage = formula(zP, highestValue);
              }
              if (item.metricKey === 'zS') {
                item.percentage = formula(zS, highestValue);
              }
              if (item.metricKey === 'trn') {
                item.percentage = formula(trn, highestValue);
              }
              if (item.metricKey === 'pb') {
                item.percentage = formula(pb, highestValue);
              }
              if (item.metricKey === 'trf') {
                item.percentage = formula(trf, highestValue);
              }
              return item;
            });
            this.overViewKpiList = addPer;

            this.overviewLoading = false;
          }
        } else {
          setTimeout(this.refreshOverview, 1000);
        }
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: `${e}`
        });
      }
    },

    async calcLastTimeStamp() {
      const apiUrl =
        'https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/data/LastModifiedStore.json';
      const config = {
        headers: {
          Authorization: ''
        }
      };
      return JSON.stringify(await axios.get(apiUrl, config));
    }
  }
};
